<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h4 class="font-weight-light">
              <span class="font-weight-bold">บิล</span>
            </h4>
          </div>
          <div class="col-sm-6 d-none d-md-block"></div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <Card>
          <div slot="body">
            <BillsTable create_path_name="Seller-Bill-Create"
                        edit_path_name="Seller-Bill-Edit"
                        @tabSelected="fetchBills"
                        @deleted="handleDelete()"
                        @search="handleSearch" />
          </div>
        </Card>
      </div>
    </section>
  </div>
</template>

<script>
import BillsTable from "@/components/derived/BillsTable";
import Card from "@/components/core/Card";
import { i18n } from "@/i18n";

export default {
  name: "Bills-List",
  components: { BillsTable, Card },
  data() {
    return {
      billRows: null,
      billCounts: null,
    };
  },

  created() {
    this.fetchBills(0);
  },

  methods: {
    handleSearch(searchData) {
      this.billRows = null;
      this.$store.dispatch("bills/searchBills", {
        ...searchData,
        callback: (status, data) => {
          this.billRows = data.results.map((d) => {
            return {
              id: d.id,
              details: {
                trackingNo: d.trackingNo,
                status: d.status,
                remarks: d.remarks,
                shippingMethod: d.shippingMethod,
                billCode: d.billCode,
                customer: {
                  name: d.customerName,
                  address: {
                    address: d.address,
                    zipcode: d.zipcode,
                    socialLink: d.socialLink,
                  },
                  phoneNo: d.phoneNo,
                },
              },
              tn: d.tn,
              createdAt: d.createdAt,
            };
          });
        },
      });
    },

    handleErrorFilter() {
      let value = parseInt(localStorage.getItem("currentTabStatus")) || 0;

      this.billRows = null;
      this.$store.dispatch("bills/fetchBills", {
        statusCode: value > 0 ? value : null,
        callback: (status, data) => {
          this.billRows = data.bills.filter((d) => {
            return d.details && d.details.hasError;
          });
          this.billCounts = [
            { label: i18n.t("tabs.all"), number: data.billCounts[0] },
            { label: i18n.t("tabs.pending"), number: data.billCounts[1] },
            { label: i18n.t("tabs.to_ship"), number: data.billCounts[2] },
            { label: i18n.t("tabs.shipped"), number: data.billCounts[3] },
            { label: i18n.t("tabs.delivered"), number: data.billCounts[4] },
            { label: i18n.t("tabs.cancelled"), number: data.billCounts[5] },
            { label: i18n.t("tabs.error"), number: data.billCounts[6] },
            {
              label: i18n.t("status.return_to_sender"),
              number: data.billCounts[8],
            },
          ];
        },
      });
    },

    handleDelete() {
      this.fetchBills();
    },

    fetchBills(value) {
      // this.billRows = null;
      // this.$store.dispatch("bills/fetchBills", {
      //   status: value,
      //   callback: (status, data) => {
      //     console.log(data)
      //     if (status) {
      //       this.billRows = data.bills;
      //       this.billCounts = [
      //         { label: "ยังไม่ชำระ", number: data.billCounts[0] },
      //         { label: "ชำระแล้ว", number: data.billCounts[1] }
      //       ];
      //     }
      //   },
      // });
    },
  },
};
</script>

<style></style>
